module.exports = __webpack_public_path__ + "static/media/4.d55c66e2.jpg";